export const asc = (a, b) => {
  const [aTitle, bTitle] = [a.title, b.title].map(str => str.toLowerCase());
  return (aTitle > bTitle)
    ? 1
    : (aTitle < bTitle)
      ? -1
      : 0;
};
